import React, { useState } from "react";
import { bool, func, number } from "prop-types";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { cedipOptions } from "util/cedip";
import Image from "pages/_components/Image";
import I18n from "pages/_components/I18n";
import ProductList from "pages/_components/product/List";
import GridTable from "pages/_components/GridTable/GridTable";
import Button from "pages/_components/Button";
import Drawer from "pages/_components/Drawer/Drawer";
import FilterTags from "../ManagementCedip/components/FilterTags";
import GridCedipItem from "./components/ItemRow";
import { useCedipTabs } from "../ManagementCedip/hooks/useCedipTabs";
import GridSideBarForm from "./components/SideBarForm";

const GridCedip = ({ isDesktop, fetchMoreTransactions, positionTab }) => {
    const { cedipList = [], fetching, hasMoreData, cedipFilters, cedipPagination } = useSelector(
        (state) => state.cedip,
    );
    const [openSidebar, setOpenSidebar] = useState(false);
    const [actionDrawer, setActionDrawer] = useState({ showDrawer: false, contentDrawer: null });
    useCedipTabs(positionTab);

    const openSideBarFilters = () => {
        setOpenSidebar(true);
    };

    const handleCloseActionDrawer = () => {
        setActionDrawer({ showDrawer: false, contentDrawer: null });
    };

    return (
        <div className="container pb-8">
            <FilterTags openSideBarFilters={openSideBarFilters} option={cedipOptions[0]} />
            {cedipList?.length === 0 && !fetching ? (
                <div className="box info service-payments__no-data">
                    <Image src="images/information_fill.svg" /> <I18n id="cedip.service.mycedip.empty" />
                </div>
            ) : (
                <ProductList
                    fetchingWithPreviousData
                    fetching={fetching}
                    items={cedipList || []}
                    noDataText="global.no.results"
                    noFiltersDataText="global.no.results"
                    renderItem={(item) => (
                        <GridTable.Container
                            key={`received-cedip-item-${item.cedipId}`}
                            renderAs={Link}
                            to={`/depositsCedip/${item.cedipId}`}
                            className={!isDesktop && "box box-shadow"}>
                            <GridCedipItem
                                receivedCedip={item}
                                setActionDrawer={setActionDrawer}
                                isDesktop={isDesktop}
                                positionTab={positionTab}
                            />
                        </GridTable.Container>
                    )}>
                    {(listItem) => (
                        <GridTable className="cedip-table tablelist received">
                            {isDesktop && (
                                <GridTable.Header>
                                    <GridTable.Container>
                                        <GridTable.Data>
                                            <I18n component="span" id="cedip.mycedip.table.title1" />
                                        </GridTable.Data>
                                        <GridTable.Data alignX="center">
                                            <I18n component="span" id="cedip.mycedip.table.title2" />
                                        </GridTable.Data>
                                        <GridTable.Data alignX="center">
                                            <I18n component="span" id="cedip.mycedip.table.title3" />
                                        </GridTable.Data>
                                        <GridTable.Data alignX="center">
                                            <I18n component="span" id="cedip.mycedip.table.title4" />
                                        </GridTable.Data>
                                        <GridTable.Data alignX="center">
                                            <I18n component="span" id="cedip.mycedip.table.title5" />
                                        </GridTable.Data>
                                        <GridTable.Data alignX="center">
                                            <I18n component="span" id="cedip.mycedip.table.title6" />
                                        </GridTable.Data>
                                        <GridTable.Data />
                                    </GridTable.Container>
                                </GridTable.Header>
                            )}
                            <GridTable.Body>{listItem}</GridTable.Body>
                            {hasMoreData && (
                                <Button
                                    bsStyle="link"
                                    onClick={() => fetchMoreTransactions(cedipPagination, cedipFilters)}
                                    image="images/figma/icon/arrow.svg"
                                    label="global.showMore"
                                    className="view-more"
                                />
                            )}
                        </GridTable>
                    )}
                </ProductList>
            )}
            <Drawer openSidebar={openSidebar} toggleSidebar={setOpenSidebar}>
                <GridSideBarForm closeSidebar={setOpenSidebar} />
            </Drawer>
            <Drawer openSidebar={actionDrawer.showDrawer} onClose={handleCloseActionDrawer}>
                {actionDrawer.contentDrawer}
            </Drawer>
        </div>
    );
};

GridCedip.propTypes = {
    isDesktop: bool.isRequired,
    fetchMoreTransactions: func.isRequired,
    positionTab: number.isRequired,
};

export default GridCedip;
